import React from "react";
import {Helmet} from "react-helmet";
import { multiSitePages } from ".";
// import {injectShopContainer} from '../../react/ShopDataContainer'
const domain = "https://blosomjapaneserestaurant.com"

export default class Base extends React.Component {
  

  render () {
    // console.log('hi', shop)
    let name = "Blosom Japanese Restaurant | Authentic ramen, teriyaki and sushi rolls in La Cienega & Koreatown, Los Angeles"
    let description = "Experience the art of Japanese dining at Blosom — Los Angeles’ modern ramen, teriyaki and sushi rolls destination with locations in La Cienega and Koreatown. Enjoy fresh sashimi, creative rolls, and premium sake in an elegant, welcoming atmosphere."

    const jsonLd = siteNavJsonLd(domain, multiSitePages);
    return (
      <Helmet>
          <meta charSet="utf-8" />
          <title>{name}</title>
          <meta name="description"
            content={description} />
          {/* <link rel="canonical" href="https://c.com" /> */}

          <link rel="manifest" href={`${process.env.PUBLIC_URL}/blosomall.json`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/blosomall.png`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/blosomall.png`} />
          <link rel="shortcut icon"
            href={`${process.env.PUBLIC_URL}/blosomall.png`}
          />

          {/* Open Graph */}
          <meta property="og:title" content={name} />
          <meta property="og:site_name" content={name} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content="https://afag.imgix.net/blosom-japanese-restaurant/hero.jpg?w=1000&auto=format" />

          <script type="application/ld+json">{jsonLd}</script>

          {/* <meta property="og:image" content={} /> */}
          {/* <meta property="og:url" content="http://euro-travel-example.com/index.htm" /> */}
      </Helmet>


    );
  }
};

// export default injectShopContainer(Base)


const siteNavJsonLd = (baseUrl, pages = []) => {
  if (!baseUrl) {
    return "";
  }

  const normalizePath = (p) =>
    "/" + String(p || "/").replace(/^\/*/, "").replace(/\/+$/, "");
  const seen = new Set();

  const elements = pages
    .filter((p) => p && p.path && p.label)
    .map((p) => {
      const path = normalizePath(p.path);
      const key = `${p.label}|${path}`;
      if (seen.has(key)) return null;
      seen.add(key);
      return {
        "@type": "SiteNavigationElement",
        name: p.label,
        url: new URL(path, baseUrl).toString(),
      };
    })
    .filter(Boolean);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: elements.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item,
    })),
  };

  return JSON.stringify(jsonLd, null, 2);
};
